import Ext from 'Ext'

export default function GenericAdditionalCheckboxExtension(extendedClass, label){

    return {
        genericCls: "generic withCheckbox",
        _createAdditionalCheckBox : function(){
            const self = this;
            this.additionalCheckBox= new Ext.form.Checkbox({
                boxLabel: label,
                checked: this.additionalCheckBoxValue,
                handler: function(){
                    self.fireEvent("change");
                }
            });
            return this.additionalCheckBox;
        },

        getPreFooterSection: function()
        {
            return [this._createAdditionalCheckBox()];
        },

        getAdditionalCheckboxValue : function(){
            if(this.additionalCheckBox){
                return this.additionalCheckBox.getValue();
            } else {
                return this.additionalCheckBoxValue;
            }
        },

        _setInitialAdditionalCheckBoxValue : function( checked ){
            this.additionalCheckBoxInitValue =   checked;
        },

        _setAdditionalCheckboxValue : function( checked ) {
            if(this.additionalCheckBox){
                if (!this.additionalCheckBox.disabled)
                    this.additionalCheckBox.setValue(checked);
                this.additionalCheckBox.prevValue = checked;
            }
        },

        loadState: function(state)
        {
            this.additionalCheckBoxValue = state.additionalCheckBoxValue;
            this._setInitialAdditionalCheckBoxValue(state.additionalCheckBoxValue);
            this._setAdditionalCheckboxValue(state.additionalCheckBoxValue);
            extendedClass.prototype.loadState.apply(this, arguments);

        },

        resetState: function(isEnableActiveActions){
            this.additionalCheckBoxValue = this.additionalCheckBoxInitValue;
            this._setAdditionalCheckboxValue(this.additionalCheckBoxInitValue);
            extendedClass.prototype.resetState.apply(this, arguments);
        },

        setInitialValueFromCurrent: function(){
            if(this.isAlreadyShown())
            {
                this._setInitialAdditionalCheckBoxValue(this.getAdditionalCheckboxValue());
                this.setFilterFlag(this.getShowInactive());
                this.selectorTree.initializeByNodeSet(this.makeNodeSet(this.getSelection()));
                this.setInitialOptionValue( !this.isCustomOptionSelected());
                this.updateInitialTreeSet();
            }
        },

        getLabelTextTemplate: function()
        {
            let result = extendedClass.superclass.getLabelTextTemplate.apply(this, arguments);
            if (this.getAdditionalCheckboxValue() === true)
                result += " (" + label + ")";
            return result;
        },

        collectCurrentSettings: function() {
            let settings = extendedClass.prototype.collectCurrentSettings.apply(this, arguments)
            settings.additionalCheckBoxValue = this.getAdditionalCheckboxValue()
            return settings
        },

        getStateFromSettings: function(settings) {
            const state = extendedClass.prototype.getStateFromSettings.apply(this, arguments)
            state.additionalCheckBoxValue = this.getAdditionalCheckboxValue()
            return state
        }
    }
};



// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_selector_panel_generic_additional_checkbox_extension.js